<template>
  <div class="tw:border tw:rounded-lg tw:border-gray-300 tw:bg-gray-100 tw:p-4 tw:flex tw:flex-col">
    <button
      type="button"
      @click="toggleCard"
      class="tw:hover:cursor-pointer tw:w-full tw:flex tw:justify-between tw:items-center tw:text-left tw:transition-colors tw:bg-transparent tw:border-none tw:p-0">
      <div class="tw:flex tw:flex-row tw:items-center tw:gap-x-2">
        <img :src="icon.href" :alt="title" />
        <h4 class="tw:font-bold">{{ title }}</h4>
      </div>
      <svg
        class="tw:w-[18px] tw:h-[18px] tw:text-[#171717] tw:transition-transform tw:duration-300"
        :class="{ 'tw:rotate-180': isOpen }"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </button>

    <div
      class="tw:grid tw:transition-all tw:duration-300 tw:ease-in-out"
      :class="isOpen ? 'tw:mt-4 tw:grid-rows-[1fr]' : 'tw:mt-0 tw:grid-rows-[0fr]'"
      :aria-hidden="!isOpen">
      <div class="tw:overflow-hidden">
        <slot name="imagesCardContent" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { selectedAccommodationId } from '@/layouts/queries'

import appAnalytics from '@/utils/tracking'

interface Props {
  icon: URL
  title: string
  defaultOpen?: boolean
  type: 'main-image-tips' | 'images-quality' | 'images-not-permitted'
}
const props = withDefaults(defineProps<Props>(), {
  defaultOpen: false,
})

const isOpen = ref(props.defaultOpen)
const toggleCard = () => {
  if (props.type === 'main-image-tips' && isOpen.value) {
    appAnalytics.track(appAnalytics.events.PD_CLOSE_MAIN_IMAGE_BEST_PRACTICES, {
      item_id: selectedAccommodationId.value,
    })
  } else if (props.type === 'main-image-tips' && !isOpen.value) {
    appAnalytics.track(appAnalytics.events.PD_OPEN_MAIN_IMAGE_BEST_PRACTICES, {
      item_id: selectedAccommodationId.value,
    })
  } else if (props.type === 'images-quality' && !isOpen.value) {
    appAnalytics.track(appAnalytics.events.PD_OPEN_IMAGE_QUALITY, {
      item_id: selectedAccommodationId.value,
    })
  } else if (props.type === 'images-not-permitted' && !isOpen.value) {
    appAnalytics.track(appAnalytics.events.PD_OPEN_IMAGES_NOT_PERMITTED, {
      item_id: selectedAccommodationId.value,
    })
  }
  isOpen.value = !isOpen.value
}
</script>
